export const { APP_ENV } = process.env;
export const { SITE_HOST } = process.env;
export const UNSUBSCRIBE = 'unsubscribe';
export const SUBSCRIBE = 'subscribe';
export const FORWARD = 'forward';
export const SWEEPS = 'sweeps';
export const AUTHOR_IMAGE_PLACEHOLDER = 'https://static.cdn.gallerymediagroup.com/purewow/logos/purewow-mark-salmon.jpg';
export const SOCIAL_SHARE_IMAGE_DEFAULT = 'https://static.cdn.gallerymediagroup.com/purewow/logos/purewow-mark-salmon.jpg';
export const CATEGORY_ROSTER = 'roster';
export const CATEGORY_FEATURED_CONTENT = 'featured-content';
export const DFP_ID = '80524299';
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^(\([0-9]{3}\) |\([0-9]{3}\)|[0-9]{3}-|[0-9]{3})([0-9]{3}-[0-9]{4}|[0-9]{3}[0-9]{4})$/;
export const ZIP_REGEX = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
export const ONE37_EMAIL_COOKIE = 'o37_e';
export const ONE37_PHONE_COOKIE = 'o37_p';
export const SOCIALS_MAP = {
  instagram: {
    href: 'https://www.instagram.com/purewow/',
    className: 'icon-instagram',
  },
  podcast: {
    href: 'https://www.purewow.com/podcasts',
    className: 'icon-podcast-icon',
  },
  pinterest: {
    href: 'https://pinterest.com/purewow',
    className: 'icon-pinterest',
  },
  twitter: {
    href: 'https://twitter.com/purewow',
    className: 'icon-twitter',
  },
  facebook: {
    href: 'https://www.facebook.com/PureWow/',
    className: 'icon-facebook',
  },
  youtube: {
    href: 'https://www.youtube.com/user/PureWowVideos',
    className: 'icon-youtube',
  },
};
